import type { IntlShape } from "react-intl";
import type InputType from "../../Input/InputType";
import Beam from "../Beam";

export default class Shortened extends Beam {
	public static code = "beam_shortened";

	public getDimensionsString(input: InputType, intl: IntlShape): string | undefined {
		if (input.length !== undefined) {
			const { length } = this.formatInputs(input, intl);

			return length?.toString();
		}
		return undefined;
	}
}
